// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__2x7jR","upload":"Small_upload__2vWM5","imageWrap":"Small_imageWrap__fMczp","removeBtn":"Small_removeBtn__WTPQN"};